/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kusama_Chain_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "ParachainSystem, ParaInherent and Timestamp" |
*
* @param {Kusama_Chain_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const kusama_chain_tps_explanation = /** @type {((inputs?: Kusama_Chain_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kusama_Chain_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("ParachainSystem, ParaInherent and Timestamp")
});